import { BrickWall } from "lucide-react";

interface Props {
  title: string;
  description?: React.ReactNode;
  children: React.ReactNode;
}

// Sign-in, invitation and password-reset pages: a brand panel next to a narrow form.
const AuthLayout: React.FC<Props> = ({ title, description, children }) => (
  <div className="grid min-h-full lg:grid-cols-2">
    <div className="brick-pattern relative hidden flex-col justify-between bg-primary p-10 text-primary-foreground lg:flex">
      <div className="flex items-center gap-2 text-lg font-semibold">
        <BrickWall className="size-6" />
        Brixture
      </div>
      <p className="max-w-sm text-lg leading-snug text-primary-foreground/90">
        Beheer de stenen die je klanten in de gevelconfigurator kiezen.
      </p>
    </div>
    <div className="flex items-center justify-center p-6 md:p-10">
      <div className="grid w-full max-w-sm gap-6">
        <div className="flex items-center gap-2 font-semibold lg:hidden">
          <span className="flex size-8 items-center justify-center rounded-lg bg-primary text-primary-foreground">
            <BrickWall className="size-4" />
          </span>
          Brixture
        </div>
        <div className="grid gap-1">
          <h1 className="text-2xl font-semibold tracking-tight">{title}</h1>
          {description && <p className="text-sm text-muted-foreground">{description}</p>}
        </div>
        {children}
      </div>
    </div>
  </div>
);

export default AuthLayout;
